import { render, staticRenderFns } from "./aboutEleTable.vue?vue&type=template&id=69b387ec&scoped=true"
import script from "./aboutEleTable.vue?vue&type=script&lang=js"
export * from "./aboutEleTable.vue?vue&type=script&lang=js"
import style0 from "./aboutEleTable.vue?vue&type=style&index=0&id=69b387ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b387ec",
  null
  
)

export default component.exports